/** Number of pages needed for `totalItems`. Never below 1, so an empty list is "page 1 of 1". */
export function pageCount(totalItems: number, pageSize: number): number {
  return Math.max(1, Math.ceil(totalItems / pageSize));
}

/** The items on 1-based `page`. Past the end returns an empty array. */
export function pageSlice<T>(items: readonly T[], page: number, pageSize: number): T[] {
  const start = (page - 1) * pageSize;
  return items.slice(start, start + pageSize);
}

/** "Showing 51–100 of 240". Empty when there is nothing to show. */
export function pageRangeLabel(totalItems: number, page: number, pageSize: number): string {
  if (totalItems === 0) return '';
  const first = (page - 1) * pageSize + 1;
  const last = Math.min(page * pageSize, totalItems);
  return `Showing ${first}–${last} of ${totalItems}`;
}
